import { NotFoundComponent } from "@website/widget-v2/not-found";
import { Header } from "@website/widget/header";
import { GetServerSideProps } from "next";

export default function Custom404() {
  return (
    <div>
      <Header title="ویلا" />
      <NotFoundComponent />
    </div>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.statusCode = 410;
  return {
    props: {}
  };
};
